import {z} from 'zod';

import i18n from '@dms/i18n';

export const SelectableMaterialFormSchema = z.object({
  integrationId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
});

export type SelectableMaterialForm = z.infer<typeof SelectableMaterialFormSchema>;
